import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper, IconButton} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import CustomField from '../CustomField/CustomField';
import ContentAdd from 'material-ui/svg-icons/content/add';
import style from "../../../styles/styles";
import {white} from "material-ui/styles/colors";
import withTranslation from "../../../hoc/withTranslation";

class CustomFieldList extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        handleAddCustomField: PropTypes.func,
        handleRemoveCustomField: PropTypes.func
    };

    static defaultProps = {
        loading: false,
        customFields: []
    };

    // Render

    render() {
        const {loading, customFields, title, app, user} = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false}/>;
        } else if (customFields.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('settings_page.add_some_custom_field')}
                />
        } else {
            content = customFields.map((cf, index) => {
                return (
                    <div key={cf.id}>
                        <CustomField
                            handleRemoveCustomField={this.props.handleRemoveCustomField}
                            user={user}
                            app={app}
                            customField={cf}
                        />
                        {index !== (customFields.length - 1) && <Divider inset={true}/>}
                    </div>
                )
            })
        }

        return (
            <div>
                <Paper>
                    <List>
                        <Subheader style={{...style.subHeader, ...style.relative}}>
                            {title}
                            {this.props.handleAddCustomField && (
                                <IconButton
                                    onClick={this.props.handleAddCustomField}
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_custom_field')}
                                    tooltipPosition='top-center'
                                >
                                    <ContentAdd color={white}/>
                                </IconButton>
                            )}
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

export default withTranslation(CustomFieldList);



// WEBPACK FOOTER //
// src/components/customfield/CustomFieldList/CustomFieldList.js